import { render, staticRenderFns } from "./FilterFarmacias.vue?vue&type=template&id=6b151d7a&scoped=true"
import script from "./FilterFarmacias.vue?vue&type=script&lang=js"
export * from "./FilterFarmacias.vue?vue&type=script&lang=js"
import style0 from "./FilterFarmacias.vue?vue&type=style&index=0&id=6b151d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b151d7a",
  null
  
)

export default component.exports